import WorkflowBox from "./WorkflowBox";
import { WorkflowBoxProps } from "./WorkflowBox";
import AgentNode from "../AgentNode/AgentNode";

const FloatingWorkflowBoxPanel = ({
    workflowType,
    workflowTitle,
    workflowBoxIndex,
    savedAction,
    onNodeSave,
    nodeIdsAbove,
    workflowNode,
    nodeConfigs,
    openByDefault,
    shouldDeleteNode,
    updateNodeConfigsFromRunInstances,
    testRunInputs,
    selectedRunInstanceId,
    setSelectedRunInstanceId,
    refetchTestRunInputs,
    setNodeConfigs,
    nodeResponseConfigs,
    setNodeResponseConfigs,
    setNodeConfigsForNodeInRef,
    getNodeConfigsForNodeFromRef,
    saveConfigField,
    executionConditionsForNode,
    topNodeIdRef,
    setIsFloatingPanelOpen,
    isTriggerNode,
    parentIsTrigger,
    triggerNodeId,
    refreshWorkflowNodes,
    setExecutionConditionsForNodes,
    getHasChildren,
    workflowNodes,
    testRunInstances,
}: WorkflowBoxProps & { setIsFloatingPanelOpen?: (open: boolean) => void }) => {
    if (!workflowNode) return null;

    return (
        <div className="absolute right-4 top-4 w-[50%] max-h-[90vh] overflow-y-auto overflow-x-hidden shadow-2xl floating-workflow-panel">
            {/* <button 
                onClick={() => setIsFloatingPanelOpen?.(false)}
                className="-top-2 -right-2 bg-white rounded-full w-6 h-6 flex items-center justify-center text-xs z-10"
            >
                ✕
            </button> */}
            {workflowType === "DynamicWorkflowAgent" ? (
                <AgentNode
                    isTriggerNode={isTriggerNode}
                    workflowType={workflowType}
                    workflowTitle={workflowTitle}
                    workflowBoxIndex={workflowBoxIndex}
                    savedAction={savedAction}
                    onNodeSave={onNodeSave}
                    nodeIdsAbove={nodeIdsAbove}
                    workflowNode={workflowNode}
                    nodeConfigs={nodeConfigs}
                    openByDefault={openByDefault}
                    shouldDeleteNode={shouldDeleteNode}
                    updateNodeConfigsFromRunInstances={updateNodeConfigsFromRunInstances}
                    testRunInputs={testRunInputs}
                    selectedRunInstanceId={selectedRunInstanceId}
                    setSelectedRunInstanceId={setSelectedRunInstanceId}
                    refetchTestRunInputs={refetchTestRunInputs}
                    setNodeConfigs={setNodeConfigs}
                    nodeResponseConfigs={nodeResponseConfigs}
                    setNodeResponseConfigs={setNodeResponseConfigs}
                    setNodeConfigsForNodeInRef={setNodeConfigsForNodeInRef}
                    getNodeConfigsForNodeFromRef={getNodeConfigsForNodeFromRef}
                    saveConfigField={saveConfigField}
                    executionConditionsForNode={executionConditionsForNode}
                    topNodeIdRef={topNodeIdRef}
                    parentIsTrigger={parentIsTrigger}
                    triggerNodeId={triggerNodeId}
                    refreshWorkflowNodes={refreshWorkflowNodes}
                    setExecutionConditionsForNodes={setExecutionConditionsForNodes}
                    getHasChildren={getHasChildren}
                    workflowNodes={workflowNodes}
                    testRunInstances={testRunInstances}
                />
            ) : (
                <WorkflowBox
                    isTriggerNode={isTriggerNode}
                    workflowType={workflowType}
                    workflowTitle={workflowTitle}
                    workflowBoxIndex={workflowBoxIndex}
                    savedAction={savedAction}
                    onNodeSave={onNodeSave}
                    nodeIdsAbove={nodeIdsAbove}
                    workflowNode={workflowNode}
                    nodeConfigs={nodeConfigs}
                    openByDefault={openByDefault}
                    shouldDeleteNode={shouldDeleteNode}
                    updateNodeConfigsFromRunInstances={updateNodeConfigsFromRunInstances}
                    testRunInputs={testRunInputs}
                    selectedRunInstanceId={selectedRunInstanceId}
                    setSelectedRunInstanceId={setSelectedRunInstanceId}
                    refetchTestRunInputs={refetchTestRunInputs}
                    setNodeConfigs={setNodeConfigs}
                    nodeResponseConfigs={nodeResponseConfigs}
                    setNodeResponseConfigs={setNodeResponseConfigs}
                    setNodeConfigsForNodeInRef={setNodeConfigsForNodeInRef}
                    getNodeConfigsForNodeFromRef={getNodeConfigsForNodeFromRef}
                    saveConfigField={saveConfigField}
                    executionConditionsForNode={executionConditionsForNode}
                    topNodeIdRef={topNodeIdRef}
                    parentIsTrigger={parentIsTrigger}
                    triggerNodeId={triggerNodeId}
                    refreshWorkflowNodes={refreshWorkflowNodes}
                    setExecutionConditionsForNodes={setExecutionConditionsForNodes}
                    getHasChildren={getHasChildren}
                    workflowNodes={workflowNodes}
                    testRunInstances={testRunInstances}
                />
            )}
        </div>
    );
};

export default FloatingWorkflowBoxPanel;